import React from 'react';
import PropTypes from 'prop-types';
import Popover from '@mui/material/Popover';
import { formatSeconds } from '../../utils/time';

// eslint-disable-next-line no-nested-ternary
const getAmPm = (hour) => (hour === 24 ? 'am' : hour >= 12 ? 'pm' : 'am');

const formatQualityTimeMessage = ({ activeSeconds }) => {
  if (Number.isNaN(activeSeconds)) return 'Manual Time';
  if (activeSeconds === 0) return 'Offline';
  if (activeSeconds < 60) {
    return `Quality Time: < ${formatSeconds(60, { roundToNearestMinute: false })}`;
  }
  return `Quality Time: ${formatSeconds(activeSeconds, { roundToNearestMinute: false })}`;
};

// Dark rounded tooltip in our design-system style (ink-900 panel, no MUI
// paper chrome), replacing the old gray-header card.
const paperSx = {
  backgroundColor: '#0e1e40',
  color: '#fff',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(14, 30, 64, 0.25)',
  marginTop: '-8px',
  overflow: 'visible',
};

function BarPopup({
  open, anchorEl, handlePopoverClose, hour, hourInfo,
}) {
  const { activeSeconds, focusMessage } = hourInfo;
  const startTime = `${(hour % 12) || 12}${getAmPm(hour)}`;
  const endTime = `${(hour % 12) + 1}${getAmPm(hour + 1)}`;

  return (
    <Popover
      id="mouse-over-popover"
      sx={{ pointerEvents: 'none' }}
      PaperProps={{ sx: paperSx }}
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: -10,
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      onClose={handlePopoverClose}
      disableRestoreFocus
    >
      <div className="px-3 py-2 whitespace-nowrap text-left">
        <p className="text-xs font-semibold text-white mb-0.5">
          {`${startTime} - ${endTime}`}
        </p>
        <p className="text-xs text-white/80 mb-0">
          {focusMessage && (
            <span className="font-medium">
              {focusMessage}
              {' · '}
            </span>
          )}
          {formatQualityTimeMessage({ activeSeconds })}
        </p>
      </div>
    </Popover>
  );
}

BarPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.shape({}),
  handlePopoverClose: PropTypes.func.isRequired,
  hour: PropTypes.number.isRequired,
  hourInfo: PropTypes.shape({
    activeSeconds: PropTypes.number.isRequired,
    focusMessage: PropTypes.string,
    color: PropTypes.string.isRequired,
  }),
};

export default BarPopup;
